import { vakanties } from '@vakantiesnl/design-tokens';
import { Theme } from '@vakantiesnl/types';

import { type NewTheme } from '../zoover/newTheme';

export const vakantiesTheme: NewTheme = { themeName: Theme.vaknl, ...vakanties };
